import React from 'react';
import { useDispatch } from 'react-redux';
import { Box, Button, Typography, Alert } from '@mui/material';

function DataInitializer() {
  const dispatch = useDispatch();

  const initializeSampleData = () => {
    // This would typically dispatch actions to load data from the backend
    // For now, we'll just show what needs to be done
    console.log('Data initialization needed - this should load data from backend APIs');
    
    // In a real scenario, you would dispatch actions like:
    // dispatch(loadStudents());
    // dispatch(loadTeachers());
    // dispatch(loadExpenses());
    // etc.
  };

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Data Initialization
      </Typography>
      
      <Alert severity="info" sx={{ mb: 2 }}>
        The accounting system requires data to be loaded from the backend. 
        Make sure the following data is available:
      </Alert>
      
      <Typography variant="h6" gutterBottom>
        Required Data Sources:
      </Typography>
      
      <ul>
        <li>Students (with finance data)</li>
        <li>Teachers (with salary data)</li>
        <li>Expenses</li>
        <li>Sales</li>
        <li>Assets</li>
        <li>Classes</li>
        <li>School Details</li>
      </ul>
      
      <Typography variant="body2" sx={{ mt: 2, mb: 2 }}>
        To load this data, you typically need to:
      </Typography>
      
      <ol>
        <li>Ensure the backend server is running</li>
        <li>Make API calls to load data into Redux store</li>
        <li>Check that the data structure matches what the accounting system expects</li>
      </ol>
      
      <Button 
        variant="contained" 
        onClick={initializeSampleData}
        sx={{ mt: 2 }}
      >
        Initialize Data (Debug)
      </Button>
    </Box>
  );
}

export default DataInitializer;
